import { memo } from "react";
import { ActionButton } from "./ui/action-button";
import { Pause, Play } from "lucide-react-native";

interface PlayAudioButtonProps {
  isPlaying: boolean;
  onPress: () => void;
  disabled: boolean;
  duration: string;
  isLoading: boolean;
}

const PlayAudioButton = ({
  isPlaying,
  onPress,
  disabled,
  duration,
  isLoading,
}: PlayAudioButtonProps) => {
  return (
    <ActionButton
      variant="black"
      label={isPlaying ? `Pause` : `Play (${duration})`}
      icon={isPlaying ? Pause : Play}
      className="flex-1 !h-auto !py-3"
      onPress={onPress}
      disabled={disabled || isLoading}
    />
  );
};

export default memo(PlayAudioButton);
